import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API,
    headers: { "Content-Type": "application/json" },
});

// Prime auth header on boot if token is present
const stored = typeof window !== "undefined" ? localStorage.getItem("vortex_customer_token") : null;
if (stored) {
    api.defaults.headers.common["Authorization"] = `Bearer ${stored}`;
}

export default api;
